<template>
  <div class="bxp-form">
    <h1>Please fill in your <strong>company details</strong> below.</h1>

    <div class="bxp-form-fields">
      
      <v-text-field
        label="Company name"
        prepend-inner-icon="fas fa-tag"
        color="secondary"
        v-model="companyNameValue"
        :append-outer-icon="fields.companyName.validationIcon"
        :success="fields.companyName.valid"
        :error="fields.companyName.valid === false"
        :hint="fields.companyName.validationMessage"
        :persistent-hint="true"
      />

      <v-select
        label="Company role"
        v-model="companyRoleValue"
        :items="fields.companyRole.options"
        prepend-inner-icon="fas fa-user-tag"
        color="secondary"
        :append-outer-icon="fields.companyRole.validationIcon"
        :success="fields.companyRole.valid"
      />

      <v-select
        label="Company size"
        v-model="numberEmployeesValue"
        :items="fields.numberEmployees.options"
        prepend-inner-icon="fas fa-users"
        color="secondary"
        :append-outer-icon="fields.numberEmployees.validationIcon"
        :success="fields.numberEmployees.valid"
      />

      <v-select
        label="Industry"
        v-model="industryValue"
        :items="fields.industry.options"
        prepend-inner-icon="fas fa-building"
        color="secondary"
        :append-outer-icon="fields.industry.validationIcon"
        :success="fields.industry.valid"
      />

      <v-textarea
        label="Leave us a message"
        v-model="messageValue"
        prepend-inner-icon="fas fa-envelope"
        color="secondary"
      ></v-textarea>

      <v-checkbox
        class="bxp-checkbox"
        v-model="fields.termsAccepted"
        color="secondary"
      >
        <template v-slot:label
          >I agree to bountiXP's
          <a href="/terms-of-use/" target="_blank" @click.stop>terms of use</a>
          and
          <a href="/privacy-policy/" target="_blank" @click.stop>privacy policy</a>
        </template>
      </v-checkbox>
    </div>

    <transition name="fade-in">
      <bxp-loading-screen
        v-if="loadingScreen.show"
        :success="loadingScreen.success"
      >
        <template v-slot:loading-content>
          <p class="bxp_loading-text" v-if="!success">Submitting your enquiry...</p>
        </template>
        <template v-slot:success-content>
          <p class="bxp_loading-text">
            Thank you for your enquiry! <br>
            Please check your inbox to find out what to do next.
          </p>
          <bxp-button
            color="secondary"
            href="/"
          >
            Continue browsing
          </bxp-button>
        </template>
      </bxp-loading-screen>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { formBus } from "@/formBus";

export default {
  data() {
    return {
      error: false,
      loadingScreen: {
        show: false,
        success: false
      }
    };
  },
  computed: {
    fields() {
      return formBus.fields
    },
    stepValid() {
      return (
        this.fields.companyName.valid &&
        this.fields.companyRole.valid &&
        this.fields.numberEmployees.valid &&
        this.fields.termsAccepted
      );
    },
    companyNameValue: {
      get() {
        return this.fields.companyName.value;
      },
      set(val) {
        formBus.fields.companyName.value = val;
        let valid = null;
        let message = null;
        if (val === "") {
          valid = false;
          message = "This field is incomplete";
        } else {
          valid = true;
          message = null;
        }
        this.updateValidation("companyName", valid, message);
      }
    },
    companyRoleValue: {
      get() {
        return this.fields.companyRole.value;
      },
      set(val) {
        formBus.fields.companyRole.value = val;
        this.updateValidation("companyRole", true, null);
      }
    },
    numberEmployeesValue: {
      get() {
        return this.fields.numberEmployees.value;
      },
      set(val) {
        formBus.fields.numberEmployees.value = val;
        this.updateValidation("numberEmployees", true, null);
      }
    },
    industryValue: {
      get() {
        return this.fields.industry.value;
      },
      set(val) {
        formBus.fields.industry.value = val;
        this.updateValidation("industry", true, null);
      }
    },
    messageValue: {
      get() {
        return this.fields.message.value;
      },
      set(val) {
        formBus.fields.message.value = val;
        this.updateValidation("message", true, null);
      }
    }
  },
  methods: {
    async ajaxSubmitForm() {
      //Verify reCAPTCHA
      const recaptchaResponse = await this.executeRecaptcha();
      if (!recaptchaResponse) {
        return false;
      }
      this.loadingScreen.show = true;
      //Build the data for the server
      const formData = new FormData();
      formData.append("action", "bxp_ajax_submit_enterprise_enquiry_form_1");
      formData.append("recaptcha_response", recaptchaResponse);
      formData.append("nonce", this.ajaxParams.nonce);
      formData.append("first_name", formBus.fields.firstName.value);
      formData.append("last_name", formBus.fields.lastName.value);
      formData.append("country", formBus.fields.country.value);
      formData.append("mobile_number", formBus.fields.mobileNumber.value);
      formData.append("email", formBus.fields.email.value);
      formData.append("company_name", formBus.fields.companyName.value);
      formData.append("company_role", formBus.fields.companyRole.value);
      formData.append("number_employees", formBus.fields.numberEmployees.value);
      formData.append("industry", formBus.fields.industry.value);
      formData.append("message", formBus.fields.message.value);
      //"Hidden" fields
      formData.append("http_referrer", this.referrerParams.httpReferrer);
      formData.append("cta_referrer", this.referrerParams.ctaReferrer);
      //Add the Hubspot Tracking Code to the submission
      formData.append("hubspotutk", this.getHsTrackingCode());

      //Send to the server
      axios.post(this.ajaxParams.ajaxurl, formData).then(response => {
        if (response.data.error) {
          this.loadingScreen.show = false;
          formBus.errorMessage = response.data.error;
          formBus.error = true;
        }
        if (response.data.success) {
          this.loadingScreen.success = true;
          this.triggerGtmThankYouEvent();
        }
      });
    }
  },
  created() {
    //Register submit callback
    this.$formController.$submitCallback = this.ajaxSubmitForm
  }
};
</script>
